//
// Module for Reporting Configuration Edit view
//
rs.module("fund/configuration/reportingconfiguration/edit",

    ["common/visibility"],

    function (visibility) {
        // Initialize the module
        function initialize(jsSelectors, codeValues) {
            var form = $.js(jsSelectors.form);
            var fundDefaultCheckbox = form.js(jsSelectors.fundDefaultCheckbox);
            var employerGridContainer = form.js(jsSelectors.employerGridContainer);
            var exceptionToleranceCheckbox = form.js(jsSelectors.exceptionToleranceCheckbox);
            var exceptionTolerancePercent = form.js(jsSelectors.exceptionTolerancePercent);
            var salaryVarianceCheckbox = form.js(jsSelectors.salaryVarianceCheckbox);
            var salaryVariancePercent = form.js(jsSelectors.salaryVariancePercent);
            var paymentPenaltyMethodSelector = form.js(jsSelectors.paymentPenaltyMethodSelector);
            var paymentPenaltyAmount = form.js(jsSelectors.paymentPenaltyAmount);
            var paymentPenaltyPercent = form.js(jsSelectors.paymentPenaltyPercent);

            // enable/disable exception tolerance textbox based on the checkbox
            exceptionToleranceCheckbox.change(function () {
                exceptionTolerancePercent.prop("disabled", !exceptionToleranceCheckbox.is(":checked"));
                if (!exceptionToleranceCheckbox.is(":checked")) {
                    exceptionTolerancePercent.val("0.00000%");
                    exceptionTolerancePercent.clearErrors();
                }
            });

            // enable/disable salary variance textbox based on the checkbox
            salaryVarianceCheckbox.change(function () {
                salaryVariancePercent.prop("disabled", !salaryVarianceCheckbox.is(":checked"));
                if (!salaryVarianceCheckbox.is(":checked")) {
                    salaryVariancePercent.val("0.00000%");
                    salaryVariancePercent.clearErrors();
                }
            });

            // enable/disable controls when the payment method is changed
            paymentPenaltyMethodSelector.change(function () {
                var isAmount = paymentPenaltyMethodSelector.val() == codeValues.flatPerDay;
                var isEmpty = paymentPenaltyMethodSelector.val() == "";

                if (isAmount || isEmpty) {
                    paymentPenaltyPercent.val("0.00000%");
                    paymentPenaltyPercent.clearErrors();
                }

                if (!isAmount || isEmpty) {
                    paymentPenaltyAmount.val("$0.00");
                    paymentPenaltyAmount.clearErrors();
                }

                paymentPenaltyAmount.prop("disabled", !isAmount || isEmpty);
                paymentPenaltyPercent.prop("disabled", isAmount || isEmpty);
            });

            // show/hide the grid when fund default is checked
            fundDefaultCheckbox.change(function () {
                visibility.setVisible(employerGridContainer, !fundDefaultCheckbox.is(":checked"));
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);